/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Group_Add_PlaceholderInputs */

const en_users_group_add_placeholder = /** @type {(inputs: Users_Group_Add_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add group…`)
};

const pt_br2_users_group_add_placeholder = /** @type {(inputs: Users_Group_Add_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar grupo…`)
};

/**
* | output |
* | --- |
* | "Add group…" |
*
* @param {Users_Group_Add_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_group_add_placeholder = /** @type {((inputs?: Users_Group_Add_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Group_Add_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_group_add_placeholder(inputs)
	return pt_br2_users_group_add_placeholder(inputs)
});